import { render, staticRenderFns } from "./ModalDeleteSpace.vue?vue&type=template&id=0cbd331a"
import script from "./ModalDeleteSpace.vue?vue&type=script&lang=js"
export * from "./ModalDeleteSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports